import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import AmexImage from '../../AmexMarketingUtils/AmexImage';
import { BREAKPOINTS } from '../../AmexMarketingUtils/constants';
import './ResyRewardsAppHome.scss';

const ResyRewardsAppHome = ({ appHomeConfig, matchMedia, urlPrefix }) => {
  const {
    title,
    copy,
    images,
    image_alt: imageAlt = '',
  } = appHomeConfig || {};

  if (!title) return null;

  return (
    <section className="ResyRewardsAppHome">
      <div className="container">
        <div className="ResyRewardsAppHome__inner">
          <div className="ResyRewardsAppHome__card">
            <h2
              className="ResyRewardsAppHome__title"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: sanitizeString(title) }}
            />
            {copy && (
              <p
                className="ResyRewardsAppHome__copy"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: sanitizeString(copy) }}
              />
            )}
          </div>
          {images && (
            <div className="ResyRewardsAppHome__media">
              <AmexImage
                images={images}
                imageAlt={imageAlt}
                mediaBreakpoint={BREAKPOINTS.MEDIUM}
                matchMedia={matchMedia}
                urlPrefix={urlPrefix}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

ResyRewardsAppHome.propTypes = {
  appHomeConfig: PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.string,
    image_alt: PropTypes.string,
    images: PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
    }),
  }),
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  urlPrefix: PropTypes.string.isRequired,
};

ResyRewardsAppHome.defaultProps = {
  appHomeConfig: null,
};

export default ResyRewardsAppHome;
